import React from 'react'
import { Route } from 'react-router-dom'
import Inicio from './inicio/InicioPage'
import SwitchRouter from 'components/SwitchRouter'

export default function Routes() {
    return (
        <SwitchRouter>
            <Route path="/departamento-pessoal" restricted='departamento-pessoal>list' component={Inicio} />
        </SwitchRouter>
    )
}
